/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';
import React from 'react';

import { Button, Modal } from '@mairistem/composants';

interface AssistantModalFinTraitementHubeeProps {
  /** Partenaires saisis, pour rappeler le projet créé */
  partenaire1?: { nomFamille?: string | null; prenom?: string | null };
  partenaire2?: { nomFamille?: string | null; prenom?: string | null };
  /** Création confirmée : projet créé puis demande marquée comme traitée */
  onConfirm: () => void;
  /** Retour à l'assistant, rien n'est créé */
  onCancel: () => void;
}

const libellePartenaire = (
  partenaire?: AssistantModalFinTraitementHubeeProps['partenaire1'],
) =>
  _.trim(
    `${_.toUpper(partenaire?.nomFamille ?? '')} ${partenaire?.prenom ?? ''}`,
  );

/**
 * Fin de l'assistant en mode Hubee : confirmation avant de créer le projet
 * et de clore la demande en ligne, comme la modal « Fin du traitement de la
 * demande » de l'assistant RCO (sans l'envoi d'attestation, propre au RCO).
 */
const AssistantModalFinTraitementHubee = (
  props: AssistantModalFinTraitementHubeeProps,
) => {
  const { partenaire1, partenaire2, onConfirm, onCancel } = props;

  const partenaires = _.compact([
    libellePartenaire(partenaire1),
    libellePartenaire(partenaire2),
  ]);

  return (
    <Modal
      open
      size="small"
      onClose={onCancel}
      data-testid="assistant-modal-fin-traitement-hubee"
    >
      <Modal.Header>Fin du traitement de la demande</Modal.Header>
      <Modal.Content>
        <p>
          Le projet de PACS
          {partenaires.length > 0 && (
            <>
              {' '}
              de <strong>{partenaires.join(' et ')}</strong>
            </>
          )}{' '}
          va être créé, et la demande en ligne sera marquée comme traitée.
        </p>
      </Modal.Content>
      <Modal.Actions>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Button
            basic
            content="Annuler la création"
            data-testid="assistant-modal-fin-traitement-hubee-annuler"
            onClick={onCancel}
          />
          <Button
            positive
            icon="check"
            content="Créer le projet"
            data-testid="assistant-modal-fin-traitement-hubee-valider"
            onClick={onConfirm}
          />
        </div>
      </Modal.Actions>
    </Modal>
  );
};

export default AssistantModalFinTraitementHubee;
